import {
  ApiLegacyBaseService,
  LEGACY_JSON_HEADERS,
} from 'api/apiLegacyBase.service';
import { AxiosPromise } from 'axios';
import { DResponse } from 'types/legacy/response.types';

const AUTH_ROOT = '/Ajax/LoginUser.aspx';

class AuthLegacyApiService extends ApiLegacyBaseService {
  private authPath(path: string): string {
    return `${AUTH_ROOT}/${path}`;
  }

  validate(email: string, password: string): AxiosPromise<DResponse> {
    return this.apibase.post<DResponse>(
      this.authPath('ValidateUserByEmailAndPassword'),
      { Email: email, Password: password },
    );
  }

  logInUser(email: string, password: string): AxiosPromise<DResponse> {
    const conditionalPayload = { FailedLoginCount: '0' };

    return this.apibase.post<DResponse>(this.authPath('LoginUser'), {
      Email: email,
      Password: password,
      chkRemeberPassword: 'false',
      IsPartialMemeber: 'false',
      CaptchaResponse: '',
      ...conditionalPayload,
    });
  }

  logInCallCenterAccount({
    username,
    password,
  }: {
    username: string;
    password: string;
  }): Promise<DResponse> {
    return this.apibase
      .post<DResponse>('/Ajax/CSRAccountLogin.aspx/btnCSRLogin_Click', {
        CSRUserName: username,
        CSRUserPassword: password,
        SelectedCountry: 1,
      })
      .then(({ data }) => data);
  }

  resetPassword(email: string): AxiosPromise<DResponse> {
    return this.apibase.post(this.authPath('RecoverPassword'), {
      Email: email,
    });
  }

  async logOut(totalProductCount: number): Promise<void> {
    /** axios clears default content-type header */
    await this.apibase.post<DResponse>(this.authPath('logoutuser'), null, {
      headers: LEGACY_JSON_HEADERS,
    });
    if (totalProductCount === 0) {
      await this.apibase.post('/api/sessions/logout');
    }
  }

  async extendSession() {
    await this.apibase.post('/api/sessions/extend-session').catch(() => {});
  }
}

const authLegacyApiService = new AuthLegacyApiService();
export { authLegacyApiService };
